export default __webpack_public_path__ + "static/media/0225.795b5789.jpg";